import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=24c4c689"
import script from "./navmenu.js?vue&type=script&lang=js&external"
export * from "./navmenu.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports